








































































import { Component } from 'vue-property-decorator'
import BaseDialog from '@/utils/dialog-control'
import BlockTitle from '@/components/common/BlockTitle.vue'
import $Api from '@api'
import { of } from 'rxjs'

@Component({
    components: {
        BlockTitle
    }
})
export default class BankDialog extends BaseDialog {
    form = {
        digisignRegisterStatus: ''
    }
    rules = {}

    get title() {
        return this.$t('common.btn.edit')
    }

    update() {
        return of(0)
    }

    create() {
        return of(0)
    }

    onOpen() {
    }

    onClose() {
    }
}
